import {AxiosResponse} from 'axios'
import ClientSDK from '../../../App/ClientSDK'
import {Moment} from 'moment'
import Transformer from './Transformer'
import {IApiResult, IResult} from './IResult'

class Client {
    static getData = (from: Moment, to: Moment, amount: number): Promise<IResult[]> =>
        ClientSDK
            .instance()
            .get(
                `report/top-customers/${from.format('YYYY-MM-DD')}/${to.format('YYYY-MM-DD')}/${amount}`
            )
            .then((response: AxiosResponse<IApiResult[]>): IResult[] => {
                return response.data.map((apiResult) => Transformer.transform(apiResult))
            })
}

export default Client
